import React from 'react';
// При количестве слайдов меньше или равном 5 и включеных параметрах `loop={true}` и `slidesPerView="auto"` уголок следующего слайда не отображается
var PROBLEM_SLIDES_COUNT = 5;
var getSlides = function getSlides(nodes) {
  if (nodes.length > PROBLEM_SLIDES_COUNT) {
    return nodes;
  }
  var count = Math.ceil(PROBLEM_SLIDES_COUNT / nodes.length) * nodes.length;
  return Array.from({
    length: count
  }).map(function (_, i) {
    return nodes[i % nodes.length];
  });
};

/**
 * @description хук для решения проблемы отображения слайдов при `loop={true}` и `slidesPerView="auto"`,
 * решает проблему отображения следующего слайда
 */
export var useVirtualSlides = function useVirtualSlides(_ref) {
  var children = _ref.children,
    loop = _ref.loop,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'default' : _ref$mode;
  var nodes = React.Children.toArray(children);

  // Для одного слайда loop отключается
  // Слайды дополняются если их меньше количества где проблема отсутствует, loop включен и это BannerGroup
  if (loop && mode === 'group' && nodes.length < PROBLEM_SLIDES_COUNT && nodes.length > 1) {
    return getSlides(nodes);
  }
  return nodes;
};